import React from "react";
import { MODAL_DELETE_SEARCH, MODAL_LOAD_SEARCH, MODAL_SAVE_SEARCH } from "../common/components/modals/constants";
import { Modals } from "../common/components/modals/Modals";
import { Toasts } from "../common/components/toasts/Toasts";
import useSearch from "../search/result/useSearch";
import { DeleteSearch } from "../search/searches/load/DeleteSearch";
import { LoadSearch } from "../search/searches/load/LoadSearch";
import { SaveSearch } from "../search/searches/save/SaveSearch";
import useEnterToSearch from "../search/useEnterToSearch";
import { Initializers } from "./Initializers";
import { NewsSearchHeader } from "./NewsSearchHeader";
import { NewsSearchResultsContainer } from "./result/NewsSearchResultsContainer";
import { NewsSidebar } from "./sidebar/NewsSidebar";
import { SearchAd } from "../search/SearchAd";
import { searchDefinition } from "../search/SearchContainer";

interface NewsSearchContainerProps {
	definition: searchDefinition;
}

export function NewsSearchContainer({
	definition: {
		namespace,
		searchTitle,
		criteria,
		searches,
		layoutSwitcher,
		resultTableConfig,
		showResultsOnInitialPageLoad = false,
		supportLink,
	},
}: NewsSearchContainerProps) {
	const { searchesEnabled, searchAlertEnabled } = searches;
	const { onSearch } = useSearch();
	useEnterToSearch(onSearch);

	const modals = {
		[MODAL_LOAD_SEARCH]: (
			<LoadSearch
				namespace={namespace}
				searchAlertEnabled={searchAlertEnabled}
				searchesEnabled={searchesEnabled}
				modalKey={MODAL_LOAD_SEARCH}
			/>
		),
		[MODAL_DELETE_SEARCH]: (
			<DeleteSearch
				namespace={namespace}
				modalKey={MODAL_DELETE_SEARCH}
			/>
		),
		[MODAL_SAVE_SEARCH]: (
			<SaveSearch
				namespace={namespace}
				searches={searches}
				modalKey={MODAL_SAVE_SEARCH}
			/>
		),
	};

	return (
		<section className="section--search section--search-with-sidebar">
			<div className="search-container">
				<Initializers
					namespace={namespace}
					criteria={criteria.criteria}
					showResultsOnInitialPageLoad={showResultsOnInitialPageLoad}
					searchesEnabled={searchesEnabled}
				/>
				<SearchAd code="hero_banner_main" />
				<NewsSearchHeader
					title={searchTitle}
					layoutSwitcher={layoutSwitcher}
					supportLink={supportLink}
				/>

				<div className="search-results-sidebar-container">
					<NewsSearchResultsContainer
						resultTableConfig={resultTableConfig}
					/>
					<NewsSidebar
						criteria={criteria.criteria}
						namespace={namespace}
						searchesEnabled={searchesEnabled}
					/>
				</div>

				<Modals modalsList={modals} />
				<Toasts />
			</div>
		</section>
	);
}
